import { takeEvery, put, call, select } from 'redux-saga/effects'

import api from 'api'

import {
  getGroupOverviewData,
  getGroupIdSelector,
  getSelectedDateRangeSelector,
  setIsFetchingGroupData,
  setGroupData,
  setLastUpdateGroupData,
  setDateRange,
} from 'redux/reducers/overview'
import {setIsRedirect} from 'redux/reducers/isRedirectForPages'

function* getGroupOverviewDataWorker(action) {
  try {
    yield put(setIsFetchingGroupData(true))
    const groupId = yield select(getGroupIdSelector)
    const selectedDate = yield select(getSelectedDateRangeSelector)

    const res = yield call(
      [api.group, 'getGroupOverview'],
      groupId,
      action.payload?.value || selectedDate.value
    )

    const { data, headers } = res

    yield put(setGroupData(data?.body))
    yield put(setLastUpdateGroupData(headers?.date || null))

    if(res.status === '400') {
      throw new Error()
    }
  } catch (error) {
    // yield put(
    //   setError({
    //     code: error?.code,
    //     message: error?.message,
    //   })
    // )
    yield put(setIsRedirect(true))
  } finally {
    yield put(setIsFetchingGroupData(false))
  }
}

export default function* overViewSagaWatcher() {
  yield takeEvery(
    [getGroupOverviewData.type, setDateRange.type],
    getGroupOverviewDataWorker
  )
}
